
import Vue from 'vue'
import GroupTransformer from '@/plugins/accountPermissions/group'

export default (group) =>
  Vue.$http.get(`/user/group_info/${group ? group : ''}`)
    .then((response) => {
      return group ? GroupTransformer.fetch(response.data) : response.data
    })



// WEBPACK FOOTER //
// ./src/services/account/fetchGroupInfo.js